import { ResponseHandler } from './../../../utils/responce-handler';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InspectionLine, ApiResponse, FinishedInspectionLine } from '../../model';
import { catchError,map } from 'rxjs/operators';
import { HttpErrorHandler } from '../../../utils/http-error-handler'
import { environment } from '../../../../environments/environment';

@Injectable()
export class InspectionLineService {
    constructor(private http: HttpClient) {
    }
    url = environment.url;
    public getInspectionLineVehicles() {
        return this.http.get<ApiResponse<InspectionLine[]>>(`${this.url}/vehicles/inprogress`)
            .pipe(map(
                data => {
                    return ResponseHandler.processData<InspectionLine[]>(data);
                }
            ), catchError(HttpErrorHandler.handleError))
    }

    public getInspectionLineStations() {
        return this.http.get<ApiResponse<InspectionLine[]>>(`${this.url}/vehicles/station`).pipe(
            map(
                data => {
                    return ResponseHandler.processData<InspectionLine[]>(data);
                }
            ), catchError(HttpErrorHandler.handleError)
        )
    }

    public getFinishedVinList() {
        return this.http.get<ApiResponse<FinishedInspectionLine[]>>(`${this.url}/vehicles/finishedVinList`).pipe(
            map(
                data => {
                    return ResponseHandler.processData<FinishedInspectionLine[]>(data);
                }
            ), catchError(HttpErrorHandler.handleError)
        )
    }

}
